module.exports = __webpack_public_path__ + "img/ph_inside.17f824db.jpg";